import styled from 'styled-components'
export const NavShape=styled.div`
width:100%;
height:80px;
background-color:#343A40;
display:flex;
align-items:center;
justify-content:center;
padding-bottom:30px;
`
export const H=styled.h1`
color :white;
font-size:40px;
margin:auto;
text-align:center;
font-style:italic;
font-weight:lighter;
margin-top:20px;
`
export const Paragraph=styled.p`
color :white;
font-size:40px;
text-align:center;
font-style:italic;
border-bottom:3px solid ;
margin:0px;
margin-bottom:20px;
`

export const Form=styled.div`
display: flex;
align-items: center;
justify-content:center;
width:45%;
margin :auto;
margin-top:20px;
background-color:black;
border-radius:15px;
flex-wrap:wrap;
flex-direction:column;
` 

export const Input=styled.input`
padding:10px;
border-radius:10px;
width:97%;
height:43px;
padding:5px;
background-color:white;
text-align:center;
font-size:20px;
font-weight:lighter;
text-align:left;
border:none;
` 

export const Reminder=styled.div`
width:95%;
display: flex;
margin :10px;
border-radius:10px;
font-size:16px;
font-family:Arial, Helvetica, sans-serif;
font-weight:lighter;
overflow:auto;
flex-direction:column;
background-color:white;
padding:5px;
 ` 
 
export const Button=styled.button`
width:97%;
height:43px;
padding:5px;
border-radius:10px;
color:white;
background-color:#0099ff;
text-align:center;
font-size:15px;
font-weight:lighter;
margin:7px;
border:none;
` 
export const DivPicker=styled.div`
display:flex;
justify-content:left;
width:97%;
height:43px;
padding:10px;
border-radius:10px;
color:white;
background-color:white;
text-align:center;
font-size:15px;
font-weight:lighter;
margin:10px;
cursor: pointer;
` 

